import { render, staticRenderFns } from "./ThematicPagesColors.vue?vue&type=template&id=2ecb7658&scoped=true&"
import script from "./ThematicPagesColors.vue?vue&type=script&lang=js&"
export * from "./ThematicPagesColors.vue?vue&type=script&lang=js&"
import style0 from "./ThematicPagesColors.vue?vue&type=style&index=0&id=2ecb7658&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecb7658",
  null
  
)

export default component.exports